/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Session } from './Session';
/**
 * 
 * @export
 * @interface Midi
 */
export interface Midi {
    /**
     * 
     * @type {number}
     * @memberof Midi
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Midi
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Midi
     */
    frequency?: number;
    /**
     * 
     * @type {Array<Session>}
     * @memberof Midi
     */
    sessionComfortableMaxNavigations?: Array<Session> | null;
    /**
     * 
     * @type {Array<Session>}
     * @memberof Midi
     */
    sessionComfortableMinNavigations?: Array<Session> | null;
    /**
     * 
     * @type {Array<Session>}
     * @memberof Midi
     */
    sessionPitchMaxNavigations?: Array<Session> | null;
    /**
     * 
     * @type {Array<Session>}
     * @memberof Midi
     */
    sessionPitchMinNavigations?: Array<Session> | null;
}

/**
 * Check if a given object implements the Midi interface.
 */
export function instanceOfMidi(value: object): value is Midi {
    return true;
}

export function MidiFromJSON(json: any): Midi {
    return MidiFromJSONTyped(json, false);
}

export function MidiFromJSONTyped(json: any, ignoreDiscriminator: boolean): Midi {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'note': json['note'] == null ? undefined : json['note'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'sessionComfortableMaxNavigations': json['sessionComfortableMaxNavigations'] == null ? undefined : ((json['sessionComfortableMaxNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionFromJSON)),
        'sessionComfortableMinNavigations': json['sessionComfortableMinNavigations'] == null ? undefined : ((json['sessionComfortableMinNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionFromJSON)),
        'sessionPitchMaxNavigations': json['sessionPitchMaxNavigations'] == null ? undefined : ((json['sessionPitchMaxNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionFromJSON)),
        'sessionPitchMinNavigations': json['sessionPitchMinNavigations'] == null ? undefined : ((json['sessionPitchMinNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionFromJSON)),
    };
}

export function MidiToJSON(json: any): Midi {
    return MidiToJSONTyped(json, false);
}

export function MidiToJSONTyped(value?: Midi | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'note': value['note'],
        'frequency': value['frequency'],
        'sessionComfortableMaxNavigations': value['sessionComfortableMaxNavigations'] == null ? undefined : ((value['sessionComfortableMaxNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionToJSON)),
        'sessionComfortableMinNavigations': value['sessionComfortableMinNavigations'] == null ? undefined : ((value['sessionComfortableMinNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionToJSON)),
        'sessionPitchMaxNavigations': value['sessionPitchMaxNavigations'] == null ? undefined : ((value['sessionPitchMaxNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionToJSON)),
        'sessionPitchMinNavigations': value['sessionPitchMinNavigations'] == null ? undefined : ((value['sessionPitchMinNavigations'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionToJSON)),
    };
}

